import "./App.css";
import {
    Routes,
    Route,
    BrowserRouter as Router,
    Navigate,
} from "react-router-dom";
import Login from "./components/Dashboard/Login/Login";
import RecentlyViewedPlans from "./components/Dashboard/RecentView/RecentlyViewedPlans";
import Layout from "./components/Layout"; // Import the Layout component
import DashBoard from "./components/Dashboard/Dash/Dashboard";
import PolicyInfo from "./components/Dashboard/PolicyList/PolicyInfo";
import Endorsement from "./components/Dashboard/Endorsement/Endorsement";
import EndorseForm from "./components/Dashboard/Endorsement/EndorseForm";
import PolicySyncing from "./components/Dashboard/PolicySyncing/PolicySyncing";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClaimInt from "./components/Dashboard/Claim/ClaimInt";
import ClaimReport from "./components/Dashboard/Claim/ClaimReport";
import ClaimSubmitt from "./components/Dashboard/Claim/ClaimSubmitt";
import Thanks from "./components/Dashboard/Claim/thanks";
import ClaimInfo from "./components/Dashboard/Claim/ClaimInfo";
import Profile from "./components/Dashboard/Header/Profile";
import "../src/components/Dashboard/PolicyRecommend/PolicyRecommend.css"
import FamilyTree from "./components/FamilyTree/FamilyTree";

export const CENTRAL_CALL = "/api/CentralCall/CallWithHeader";

const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href");

function App() {
    const PrivateRoute = ({ Component }) => {
        const isLoggedInUser = localStorage.getItem("smc-csp-token");
        return isLoggedInUser ? <Component /> : <Navigate to="/" replace />;
    };
    const isLoggedInUser = localStorage.getItem("smc-csp-token");

    //{ baseUrl }
    return (
        <>
            <ToastContainer />
            <Router basename={baseUrl}>
                <Routes>
                    <Route
                        path="/"
                        element={isLoggedInUser ? <Navigate to="/dashboard" /> : <Login />}
                    />
                    <Route path="" element={<Layout />}>
                        <Route
                            path="/dashboard"
                            exact={true}
                            element={<PrivateRoute Component={DashBoard} />}
                        />
                        <Route
                            path="/policy-details"
                            exact={true}
                            element={<PolicyInfo />}
                        />
                        <Route
                            path="/recently-viewed-plans"
                            exact={true}
                            element={<RecentlyViewedPlans />}
                        />
                        <Route
                            path="/family-hierarchy-view"
                            exact={true}
                            element={<FamilyTree />}
                        />
                        <Route
                            path="/endorsements"
                            exact={true}
                            element={<Endorsement />}
                        />
                        <Route
                            path="/endorse-form"
                            exact={true}
                            element={<EndorseForm />}
                        />
                        <Route path="/policy-sync" exact={true} element={<PolicySyncing />} />
                        <Route path="/cliam-intimation" exact={true} element={<ClaimInt />} />
                        <Route
                            path="/report-claim"
                            exact={true}
                            element={<ClaimReport />}
                        />
                        <Route
                            path="/claim-submit"
                            exact={true}
                            element={<ClaimSubmitt />}
                        />
                        <Route
                            path="/profile"
                            exact={true}
                            element={<Profile />}
                        />
                        <Route
                            path="/claim-details"
                            exact={true}
                            element={<ClaimInfo />}
                        />
                        <Route
                            path="/thanks"
                            exact={true}
                            element={<Thanks />}
                        />
                    </Route>
                </Routes>
            </Router>
        </>
    );
}

export default App;
